import React, { useState, useEffect } from "react";
import { Typography, Grid, Container, Box } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import CustomButton from "../../components/Custom/CustomButton";
import { useNavigate } from "react-router-dom";
import { CustomLabel } from "../../components/Custom/CustomTypography";
import { CustomValue } from "../../components/Custom/CustomTypography";
import { useLocation } from "react-router-dom";
import ConfirmationPopup from "../../components/Popup/GenericPopup";

export default function BidDetailedView() {
  const [bidData, setBidData] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const bidId = queryParams.get("interest_id");

  const details = bidData.commodity
    ? [
        { label: "FPO", value: bidData.to_user.full_name },
        { label: "Quantity(MT)", value: `${bidData.quantity}MT` },
        { label: "Date Needed on", value: bidData.date },
        { label: "Location", value: bidData.district.name },
        { label: "Contact", value: bidData.to_user.phone_number || "NA" },
      ]
    : [];

  useEffect(() => {
    fetchBidDetails(bidId);
  }, []);

  const fetchBidDetails = async (bidId) => {
    api
      .get(`/buyer/expression-of-interest/${bidId}/`)
      .then((result) => {
        setBidData(result.data);
        setLoading(false);
      })
      .catch((err) => {
        alert("Error: " + err.response.data.non_field_errors[0]);
        setLoading(false);
      });
  };

  const handleFulfilled = async () => {
    try {
      const response = await api.patch(
        `/buyer/expression-of-interest/${bidId}/`,
        {
          status: "Fulfilled",
        }
      );
      console.log("Bid marked as fulfilled successfully", response.data);
      setTimeout(() => {
        navigate("/");
      }, 2000);
    } catch (error) {
      console.error("Error updating bid:", error);
    }
  };

  const handleDelete = () => {
    setDeleteConfirmationOpen(true);
  };
  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      const response = await api.delete(
        `/buyer/expression-of-interest/${bidId}/`
      );
      console.log("Bid deleted successfully", response.data);
      setTimeout(() => {
        navigate("/");
      }, 100);
      setLoading(false);
    } catch (error) {
      console.error("Error deleting Bid:", error);
      setLoading(false);
    }
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: "94vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontSize: "30px",
              fontWeight: 700,
              marginTop: "10px",
            }}
          >
            {bidData.commodity ? `${bidData.commodity.name}` : ""}
          </Typography>
          <div
            style={{
              height: "100%",
              maxHeight: "100%",
              overflowY: "auto",
            }}
          >
            <CustomLabel>
              {bidData.commodity
                ? `${bidData.quantity}MT, ${bidData.district.name}, ${bidData.date}`
                : ""}
            </CustomLabel>
            <Box sx={{ marginTop: "10px" }}>
              {details.map(({ label, value }, index) => (
                <React.Fragment key={index}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <CustomLabel>
                        <Typography variant="body1" fontWeight="bold">
                          {label}:
                        </Typography>
                      </CustomLabel>
                    </Grid>
                    <Grid item xs={6}>
                      <CustomValue>
                        <Typography variant="body1">{value}</Typography>
                      </CustomValue>
                    </Grid>
                  </Grid>
                </React.Fragment>
              ))}
            </Box>
            <Box sx={{ marginTop: "10px" }}>
              {bidData.status === "Rejected" && (
                <>
                  <CustomLabel>{t("Rejection Reason :")}</CustomLabel>
                  <CustomValue>{bidData.rejection_reason}</CustomValue>
                </>
              )}
            </Box>
          </div>
          <div>
            {/* <CustomButton hideIcon onClick={handleEdit}>
            {t("Edit")}
            </CustomButton> */}
            <CustomButton
              hideIcon
              onClick={() => {
                handleFulfilled();
              }}
            >
              {t("Mark as Fulfilled")}
            </CustomButton>
            <CustomButton
              hideIcon
              backgroundColor="#CF5C5C"
              onClick={handleDelete}
            >
              {t("Delete")}
            </CustomButton>
          </div>
        </Container>
      </LoaderContainer>
      <ConfirmationPopup
        open={deleteConfirmationOpen}
        handleClose={() => setDeleteConfirmationOpen(false)}
        handleConfirm={handleConfirmDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this bid?"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
      />
    </>
  );
}
